import { QuestionAndAnswersDTO } from "./question-and-answers.model";

export class EditQuiz{
    storyName: string;
    questionAndAnswersDTO: Array<QuestionAndAnswersDTO>[];
    storybookReadingLevel: string;
    quizId: number;
}